// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ContractOffer_modalWrapper__gWqQn","header":"ContractOffer_header__H6RbI","body":"ContractOffer_body__NclR6","footer":"ContractOffer_footer__a3yS4"};